import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface LatestElpris {
  priceArea: string;
  hourDk: string | null;
  priceDkkKwh: number;
  avg24hDkkKwh: number | null;
  sourceLabel: string | null;
  sourceUrl: string | null;
}

/** Seneste spotpris fra elpris-tabellen (Energi Data Service). Ingen fallback-tal. */
export function useLatestElpris(area: 'DK1' | 'DK2' = 'DK1'): LatestElpris | null {
  const [price, setPrice] = useState<LatestElpris | null>(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const { data, error } = await supabase.rpc('get_latest_elpris', { _area: area });
        if (error || cancelled) return;
        const row = Array.isArray(data) ? data[0] : null;
        if (!row || row.price_dkk_kwh == null) return;
        setPrice({
          priceArea: row.price_area,
          hourDk: row.hour_dk,
          priceDkkKwh: Number(row.price_dkk_kwh),
          avg24hDkkKwh: row.avg_24h_dkk_kwh == null ? null : Number(row.avg_24h_dkk_kwh),
          sourceLabel: row.source_label,
          sourceUrl: row.source_url,
        });
      } catch {
        // Stille fejl — blokke der bruger elprisen skjuler sig selv
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [area]);

  return price;
}
